import React from "react";
import { IRouteListItem } from "../../service/Index";
import styles from "../../styles/index";

import record_walk from "../../assets/imgs/record_walk.png";
import record_run from "../../assets/imgs/record_run.png";
import record_cycling from "../../assets/imgs/record_cycling.png";
import record_fit from "../../assets/imgs/record_fit.png";
import record_ski from "../../assets/imgs/record_ski.png";
import record_mountain from "../../assets/imgs/record_mountain.png";
import record_skate from "../../assets/imgs/record_skate.png";

import icTime from "../../assets/imgs/ic-history-time.png";
import icSpeed from "../../assets/imgs/ic-history-speed.png";

interface IProps {
  sport: IRouteListItem;
}

enum SPORTS {
  walking = 0, // 健走
  running = 1, // 跑步
  cycling = 2, // 骑行
  ski = 3, // 滑雪
  skate = 4, // 滑冰
  mountain = 5, // 登山
  fitness = 6, // 健身
}

const SPORT_MAP: Record<SPORTS, { img: string }> = {
  [SPORTS.walking]: { img: record_walk },
  [SPORTS.running]: { img: record_run },
  [SPORTS.cycling]: { img: record_cycling },
  [SPORTS.ski]: { img: record_ski },
  [SPORTS.skate]: { img: record_skate },
  [SPORTS.mountain]: { img: record_mountain },
  [SPORTS.fitness]: { img: record_fit },
};

class ClubActivitySportItem extends React.Component<IProps, {}> {
  _formatSportRace = () => {
    const { sport } = this.props;
    const minute = Math.floor(sport.race / 60);
    const second = sport.race - minute * 60;
    return `${minute}'${second}''`;
  };

  _formatSportTime = () => {
    const { sport } = this.props;
    const base = 1 * 60 * 60;
    const hour = Math.floor(sport.total_time / base);
    const minute = Math.floor((sport.total_time - hour * base) / 60);
    const second = sport.total_time - (hour * base + minute * 60);

    return [hour, minute, second]
      .map((item) => {
        return item < 10 ? `0${item}` : item;
      })
      .join(":");
  };

  /* 获取本条记录的运动类型 */
  getSportType = () => {
    const {
      sport: { sports_type },
    } = this.props;
    const sportType: SPORTS = +sports_type;
    return sportType;
  };

  /**
   * sports_type 0 健走 1 跑步 2 骑行
   */
  _getActSportIcon = () => {
    const sportType = this.getSportType();
    // 给个默认值
    const sportInfo = SPORT_MAP[sportType] || SPORT_MAP[SPORTS.walking];
    return sportInfo.img;
  };

  render() {
    const { sport } = this.props;
    const sports_type = this.getSportType();
    const pic = this._getActSportIcon();

    return (
      <div style={styles.routeItem} className="clearfix">
        <img src={pic} style={styles.routePic} />
        <div style={styles.routeMain}>
          <p style={styles.routeStartTime}>{sport.start_time}</p>
          <p style={styles.totalLengthWrapper}>
            <span style={styles.totalLength}>
              {sports_type == SPORTS.fitness
                ? sport.total_calorie.toFixed(2)
                : (sport.total_length / 1000).toFixed(2)}
            </span>
            <span>{sports_type == SPORTS.fitness ? "千卡" : "公里"}</span>
          </p>
          <div style={styles.routeTime}>
            <span style={styles.routeTimeItem}>
              <img src={icTime} style={styles.routeIcon} />
              <span style={styles.sportTime}>{this._formatSportTime()}</span>
            </span>
            <span
              style={{
                ...styles.routeTimeItem,
                opacity: sports_type === SPORTS.fitness ? 0 : 1,
              }}
            >
              <img src={icSpeed} style={styles.routeIcon} />
              <span style={styles.sportTime}>{this._formatSportRace()}</span>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default ClubActivitySportItem;
